import './WhosOnFirstModule.css';
import wofImg from './img/wof.png';

function WhosOnFirstModule() {
    return (
        <>
            <div>
                <h3>Who' s On First?</h3>
                <img src={wofImg} width="55%" alt="whosOnFirst" />
            </div>
            <div>
                <table cellSpacing={0} className='wftable'>
                    <tbody>
                        <tr>
                            <th>BLANK</th>
                            <td>WAIT, RIGHT, OKAY, MIDDLE, BLANK</td>
                        </tr>
                        <tr>
                            <th>DONE</th>
                            <td>SURE, UH HUH, NEXT, WHAT?, YOUR, UR, YOU'RE, HOLD, LIKE</td>
                        </tr>
                        <tr>
                            <th>FIRST</th>
                            <td>LEFT, OKAY, YES, MIDDLE, NO, RIGHT, NOTHING, UHHH, WAIT</td>
                        </tr>
                        <tr>
                            <th>HOLD</th>
                            <td>YOU ARE, U, DONE, UH UH, YOU, UR, SURE, WHAT?, YOU'RE</td>
                        </tr>
                        <tr>
                            <th>LEFT</th>
                            <td>RIGHT, LEFT</td>
                        </tr>
                        <tr>
                            <th>LIKE</th>
                            <td>YOU'RE, NEXT, U, UR, HOLD, DONE, UH UH, WHAT?, UH HUH</td>
                        </tr>
                        <tr>
                            <th>MIDDLE</th>
                            <td>BLANK, READY, OKAY, WHAT, NOTHING, PRESS, NO, WAIT, LEFT</td>
                        </tr>
                        <tr>
                            <th>NEXT</th>
                            <td>WHAT?, UH HUH, UH UH, YOUR, HOLD, SURE, NEXT</td>
                        </tr>
                        <tr>
                            <th>NO</th>
                            <td>BLANK, UHHH, WAIT, FIRST, WHAT, READY, RIGHT, YES, NOTHING</td>
                        </tr>
                        <tr>
                            <th>NOTHING</th>
                            <td>UHHH, RIGHT, OKAY, MIDDLE, YES, BLANK, NO, PRESS, LEFT</td>
                        </tr>
                        <tr>
                            <th>OKAY</th>
                            <td>MIDDLE, NO, FIRST, YES, UHHH, NOTHING, WAIT, OKAY</td>
                        </tr>
                        <tr>
                            <th>PRESS</th>
                            <td>RIGHT, MIDDLE, YES, READY, PRESS</td>
                        </tr>
                        <tr>
                            <th>READY</th>
                            <td>YES, OKAY, WHAT, MIDDLE, LEFT, PRESS, RIGHT, BLANK, READY</td>
                        </tr>
                        <tr>
                            <th>RIGHT</th>
                            <td>YES, NOTHING, READY, PRESS, NO, WAIT, WHAT, RIGHT</td>
                        </tr>
                        <tr>
                            <th>SURE</th>
                            <td>YOU ARE, DONE, LIKE, YOU'RE, YOU, HOLD, UH HUH, HR, SURE</td>
                        </tr>
                        <tr>
                            <th>U</th>
                            <td>UH HUH, SURE, NEXT, WHAT?, YOU'RE, UR, UH HUH, DONE, U</td>
                        </tr>
                        <tr>
                            <th>UHHH</th>
                            <td>READY, NOTHING, LEFT, WHAT, OKAY, YES, RIGHT, NO, PRESS</td>
                        </tr>
                        <tr>
                            <th>UH HUH</th>
                            <td>UH HUH</td>
                        </tr>
                        <tr>
                            <th>UH UH</th>
                            <td>UR, U, YOU ARE, YOU'RE, NEXT, UH UH</td>
                        </tr>
                        <tr>
                            <th>UR</th>
                            <td>DONE, U, UR</td>
                        </tr>
                        <tr>
                            <th>WAIT</th>
                            <td>UHHH, NO, BLANK, OKAY, YES, LEFT, FIRST, PRESS, WHAT</td>
                        </tr>
                        <tr>
                            <th>WHAT</th>
                            <td>UHHH, WHAT</td>
                        </tr>
                        <tr>
                            <th>WHAT?</th>
                            <td>YOU, HOLD, YOU'RE, YOUR, U, DONE, UH UH, LIKE, YOU ARE</td>
                        </tr>
                        <tr>
                            <th>YES</th>
                            <td>OKAY, RIGHT, UHHH, MIDDLE, FIRST, WHAT, PRESS, READY, NOTHING</td>
                        </tr>
                        <tr>
                            <th>YOU</th>
                            <td>SURE, YOU ARE, YOUR, YOU'RE, NEXT, UH HUH, UR, HOLD, WHAT?</td>
                        </tr>
                        <tr>
                            <th>YOU'RE</th>
                            <td>YOU, YOU'RE</td>
                        </tr>
                        <tr>
                            <th>YOU ARE</th>
                            <td>YOUR, NEXT, LIKE, UH HUH, WHAT?, DONE, UH UH, HOLD, YOU</td>
                        </tr>
                        <tr>
                            <th>YOUR</th>
                            <td>UH UH, YOU ARE, UH HUH, YOUR</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    );
}

export default WhosOnFirstModule;
